import React from 'react';
import './styles.css';

const InboundItemStatus = ({ status, sentDate, replyDate }) => {
  return (
    <div className="inbound-item-status">
      {status === 'Sent' && (
        <>
          <div className="inbound-item-status__date">{sentDate}</div>
          <div className="inbound-item-status__caption inbound-item-status__caption--sent">
            UNREPLIED
          </div>
        </>
      )}
      {status === 'Replied' && (
        <>
          <div className="inbound-item-status__date">{replyDate}</div>
          <div className="inbound-item-status__caption inbound-item-status__caption--replied">
            REPLIED
          </div>
        </>
      )}

      {status === 'Returned' && null}
    </div>
  );
};

export default InboundItemStatus;
